module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1118.873e9ee5.png";